import { Alert } from 'element-ui';
import { Axios } from 'src/class/Axios.js';
import { AXIOS_URL, removeLocalStorage } from 'src/util/Util';
import { mapActions } from 'vuex';
import { MixinNotification } from 'src/mixins/mixin-notification';
import { Pagination as LPagination } from 'src/components/index';
import Formatter from '../class/Formatter';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import Tables from '../class/Tables';
import UtilFactory from '../factories/UtilFactory';

const mixinMasters = {
  components: {
    LPagination,
    [Alert.name]: Alert,
  },

  data() {
    return {
      disabledField: false,
      error: null,
      errorAlert: null,
      fuseSearch: null,
      renderComponent: true,
      modals: {
        read: false,
        create: false,
        delete: false,
        map: false,
      },
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      rowData: null,
      searchQuery: '',
      selectClass: 'select-primary',
      tableData: [],
      title: null,
    };
  },

  computed: {
    ...Tables.Search,
    nameAreasSelected() {
      return this.$i18n.t('common_words.record_selected_threepoints');
    },
  },

  mixins: [MixinNotification],

  methods: {
    // mapeamos las acciones de nuestro store para poder llamarlas desde este script
    ...mapActions({
      logout: 'auth/logout',
      revokeAccessToken: 'auth/revokeAccessToken',
      cleanUserlogout: 'auth/cleanUserlogout',
      attempt: 'auth/attempt',
    }),

    getNameSelected(dataMain, options) {
      const others = [];
      if (Array.isArray(dataMain)) {
        dataMain.forEach((element) => {
          const isFind = options.find((item) => item.id === element);
          if (isFind) others.push(isFind.name);
        });
      } else {
        return options.find((item) => item.id === dataMain).name;
      }

      return others;
    },

    updateDataPagination(reference, dataToUpdate, timeout = 100) {
      setTimeout(() => {
        if (this.$refs[reference]) {
          this.$refs[reference].froms = dataToUpdate[0];
          this.$refs[reference].tos = dataToUpdate[1];
          this.$refs[reference].totals = dataToUpdate[2];
        }
      }, timeout);
    },

    getAxiosURL() {
      return AXIOS_URL;
    },

    forceRenderMenu() {
      this.attempt(this.$store.state.auth.token).then(() => {
        this.$emit('forceRerenderMenu');
      });
    },

    selectedsSelection(selection, model_type) {
      this.model[model_type] = selection;
    },

    selectAllFromSelect(model, array_data, scope = null) {
      let util_selects = new UtilFactory(this).getUtilObject('select');
      util_selects.selectAllFromSelect(model, array_data, scope);
    },

    selectAllFromSelectSensors(model, array_data, scope = null) {
      let util_selects = new UtilFactory(this).getUtilObject('select');
      util_selects.selectAllFromSelectSensors(model, array_data, scope);
    },

    selectAllFromSelectLots($event, model, array_data, scope = null) {
      let util_selects = new UtilFactory(this).getUtilObject('select');
      util_selects.selectAllFromSelectLots($event, model, array_data, scope);
    },

    concatAll(
      data,
      nameKey = null,
      nameLabel = i18n.t('uti.mixinMasters.selectAll')
    ) {
      let concat = {};
      if (!nameKey) {
        concat = { id: 0, name: nameLabel };
      } else {
        concat['id'] = 0;
        concat[nameKey] = nameLabel;
      }

      return [concat].concat(data);
    },

    concatAllLots(data, nameKey = null) {
      let concat = {};
      if (!nameKey) {
        concat = { id: 0, name: i18n.t('uti.mixinMasters.selectAll') };
      } else {
        concat['id'] = 0;
        concat[nameKey] = i18n.t('uti.mixinMasters.selectAll');
      }

      return [concat].concat(
        data.map((el, index) => {
          return {
            id: index + 1,
            name: el,
          };
        })
      );
    },

    concatAllSensors(data) {
      let concat = {
        code: -1,
        two_name: '-1',
        name: i18n.t('uti.mixinMasters.selectAll'),
      };
      return [concat].concat(data);
    },

    buildDefaultArrayForTree(data) {
      let s_resp = [];
      for (const key in data) {
        s_resp.push({
          id: key,
          label: key.split('_')[1],
          disabled: true,
          children: data[key],
        });
      }

      return s_resp;
    },

    searchedQuery(searchedValue) {
      this.searchQuery = searchedValue;
    },

    refreshTable(route, refresh = false) {
      if (!refresh) {
        return Axios.getMasters(route);
      } else {
        this.showHideLoading(true);
        this.tableData = [];
        Axios.getMasters(route).then((response) => {
          this.showHideLoading();
          this.tableData = response.data.data;
        });
      }
    },

    validateDate(createdAt) {
      const date = moment(createdAt, 'YYYY-MM-DD HH:mm:ss', true);

      return date.isValid();
    },

    /**
     * esta accion se encarga de redireccionar al login
     * si no tiene parametros para permanecer en la aplicación
     * @param boolean do_logout
     */
    routeLogin(do_logout = true) {
      SweetAlert.warning(i18n.t('uti.mixinMasters.warningText1'));

      if (do_logout) {
        this.logout();
      } else {
        this.revokeAccessToken();
      }

      setTimeout(() => {
        this.cleanUserlogout();
        sessionStorage.clear();
        removeLocalStorage('locale');
        this.$router.push('/login');
      }, 5000);
    },

    async validateVariousSelect(amount, modelData, required) {
      const passed = [];

      for (let i = 0; i < amount; i++) {
        for (const [index, model] of modelData.entries()) {
          if (!model[i] || model[i] === '' || model[i] === null) {
            passed.push(false);
            await this.validationInput(required[index], i);
          } else {
            passed.push(true);
          }
        }
      }

      return passed;
    },

    async validationInput(reference, indexnum) {
      let elementsArray = document.getElementsByClassName(
        `required-${reference}`
      );

      for (let i = 0; i < elementsArray.length; i++) {
        if (i == indexnum) {
          let inputsArray = elementsArray[i].getElementsByTagName('input');
          for (let index of inputsArray) {
            index.focus();
            index.classList.add('custom-has-error');
            this.removeHasError(index);
            return false;
          }
        }
      }

      return true;
    },

    /**
     * Valida si los inputs requeridos en un formulario tienen datos.
     * @async
     * @param {string} reference - Clase CSS base para seleccionar los elementos requeridos (ej: "lot").
     * @param {boolean} [zeroRequired=false] - Si es `true`, permite valores "0" como válidos; si es `false`, los campos vacíos se consideran inválidos.
     * @param {boolean} [allElements=false] - Si es `true`, revisa todos los elementos; si es `false`, se detiene en el primer error encontrado.
     * @param {boolean} [selectMultiple=false] - Si es `true`, valida un `<select multiple>` comprobando si tiene valores seleccionados.
     * @returns {Promise<boolean>} `true` si todos los campos son válidos, `false` si hay errores.
     */
    async validationInputsRequired(
      reference,
      zeroRequired = false,
      allElements = false,
      selectMultiple = false
    ) {
      const elementsArray = document.querySelectorAll(`.required-${reference}`);

      for (const key of elementsArray) {
        if (selectMultiple) {
          const selectedTags = key.querySelectorAll('.el-tag');

          if (selectedTags.length === 0) {
            this.setError(key.querySelector('input'));

            return false;
          }

          continue;
        }

        const inputsArray = key.querySelectorAll('input');

        for (const index of inputsArray) {
          if (zeroRequired || index.value.trim().length === 0) {
            this.setError(index);
            if (!allElements) return false;
          }
        }
      }

      return true;
    },

    /**
     * Agrega la clase de error a un input y le da foco.
     * @param {HTMLInputElement} input - Elemento de entrada (input) al que se aplicará el error.
     */
    setError(input) {
      if (input) {
        input.focus();
        input.classList.add('custom-has-error');
        this.removeHasError(input);
      }
    },

    async removeHasError(index) {
      if (index.classList.contains('el-input__inner')) {
        setTimeout(() => {
          index.classList.remove('custom-has-error');
        }, 3000);
      }

      return true;
    },

    /**
     * Método para modificar las tablas de indexación de información
     * en la vista index
     * @param {Number} type
     * @param {Number} id
     * @param {*} response
     * @param {String} modal
     * @param {String} icon
     * @param {String} typeSweetAlert
     * @param {*} tableData
     * @param {boolean} code
     * @param {boolean} notification
     * @param {String} title
     */
    modifyTable(
      type,
      id,
      response,
      modal = null,
      icon = 'nc-settings-90',
      typeSweetAlert = 'warning',
      tableData = null,
      code = false,
      notification = true,
      title = i18n.t('uti.mixinMasters.smartNotifications')
    ) {
      tableData = tableData ? tableData : this.tableData;
      let index = code
        ? tableData.findIndex((tableRow) => tableRow.code === id)
        : tableData.findIndex((tableRow) => tableRow.id === id);

      switch (type) {
        case 0:
          tableData.push(response.data.data);
          this.closeModal('create');
          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-add',
              `${i18n.t('common_words.successful_creation')}`
            );
          }

          break;
        case 1:
          this.$set(tableData, index, response.data.data);
          this.closeModal('create');
          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-settings-tool-66',
              `${i18n.t('common_words.successful_update')}`
            );
          }
          break;
        case 2:
          if (index >= 0) {
            tableData.splice(index, 1);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}`
            );
          }
          break;
        case 3:
          this.$set(tableData, index, response.data.data);
          if (modal) {
            this.closeModal(modal);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              typeSweetAlert,
              icon,
              i18n.t('uti.mixinMasters.smartNotifications')
            );
          }
          break;
        case 4:
          if (modal) {
            this.closeModal(modal);
          }

          this.showHideLoading();
          if (notification) {
            this.showNotification(
              `${response.data.message}`,
              typeSweetAlert,
              icon,
              i18n.t('uti.mixinMasters.smartNotifications')
            );
          }
          break;
        case 5:
          this.showHideLoading();
          this.showNotification(`${response}`, typeSweetAlert, icon, title);
          break;
      }
    },

    searchFuse(keys, data = null, threshold = 0.3) {
      this.fuseSearch = new Fuse(data ? data : this.tableData, {
        useExtendedSearch: true,
        threshold: threshold,
        keys: keys,
      });
      this.showHideLoading();
    },

    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    showDownloadNotification() {
      this.showNotification(
        i18n.t('uti.mixinMasters.fileDownloadedSuccessfully'),
        'success',
        'nc-cloud-download-93',
        i18n.t('uti.mixinMasters.downloadComplete')
      );
    },

    goToFirstStep() {
      this.$refs.formWizard.reset();
    },

    showMessageErrors(error) {
      console.log(error);
      this.showHideLoading();

      let msg = `${i18n.t('common_words.ups')}<br/><br/>`;
      if (error.response && error.response.data && error.response.data.errors) {
        let i = 1;
        for (var key in error.response.data.errors) {
          msg += `${i++}. ${error.response.data.errors[key]} <br/>`;
        }
      } else {
        if (error.response) {
          if (error.response.data && error.response.data.message) {
            msg = error.response.data.message;
          } else {
            if (error.response.data.errorcode) {
              msg = error.response.data.error;
            } else {
              msg = i18n.t('uti.mixinMasters.errorSendingInformation');
            }
          }
        } else {
          msg =
            i18n.t('uti.mixinMasters.errorSendingInformation') +
            (error ? '"' + error + '"' : '');
        }
      }

      if (
        error.response &&
        ((error.response.data.code && error.response.data.code === 474, 422) ||
          (error.response.status && error.response.status === 422))
      )
        SweetAlert.warning(msg);
      else SweetAlert.danger(msg);
    },

    showHideLoading(show = false) {
      this.$emit('cotentLoading', show);
      this.$emit('showHideLoading', show);
    },

    showError(find_class_name, error_class_name, msg = false) {
      this.errorAlert = true;
      this.error = msg ? msg : i18n.t('uti.mixinMasters.errorContactTheAdmin');

      for (let index of document.getElementsByClassName(find_class_name)) {
        index.classList.add(error_class_name);
      }

      setTimeout(() => {
        this.error = null;
        this.errorAlert = false;

        for (let index of document.getElementsByClassName(find_class_name)) {
          index.classList.remove(error_class_name);
        }
      }, 5000);
    },

    highlightItem(class_name) {
      for (let index of document.getElementsByClassName(class_name)) {
        let sel = index.getElementsByClassName('el-input__inner')[0];
        sel.focus();
        sel.classList.add('custom-has-error');
        this.removeHasError(sel);
      }
    },

    forceRerender() {
      // remove the my-component component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // add my-component component in DOM
        this.renderComponent = true;
      });
    },

    autoSelectElements(type, dataElements) {
      if (dataElements.length == 1) {
        switch (Number(type)) {
          case 0:
            return dataElements[0].id;
          default:
            return [dataElements[0].id];
        }
      }

      return Number(type) === 1 ? [] : null;
    },

    selectElementsAsignFromModel(type, modelFormElement, dataElements = []) {
      let elements = [];
      if (!this.$store.state.auth.permissions.includes('Super Administrador')) {
        elements = this.$store.state.auth.user.business.filter((item) => {
          return item.id != 1;
        });
      } else {
        elements = this.$store.state.auth.user.business;
      }

      if (dataElements.length > 0) {
        let resultForEach = [];
        dataElements.forEach((element) => {
          const result = elements.find((business) => business.id == element.id);
          if (result) resultForEach.push(result);
        });

        elements = resultForEach;
      }

      switch (type) {
        case 0:
          if (elements.length == 1) {
            modelFormElement = elements[0].id;
          }
          break;
        default:
          modelFormElement = elements.map((business) => business.id);
          break;
      }

      return modelFormElement;
    },

    formatterNumber(row, column) {
      return Formatter.formatMoney(Number(row[column.property]));
    },

    formatterNumberM(row, column) {
      return Formatter.formatNumber(Number(row[column.property]));
    },

    formatterNumberMS(row, column) {
      if (typeof row[column.property] !== 'undefined') {
        return Formatter.formatNumber(parseFloat(row[column.property]));
      } else {
        return Formatter.formatNumber(Number(row[column.property]));
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total';
          return;
        }

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = Formatter.formatMoney(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0),
            3
          );
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },

    getSummariesAndOneAVG(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = 'Total';
          return;
        }

        if (index === 7) {
          let suma_peso_caja = 0;
          data.forEach((element) => {
            suma_peso_caja += element.peso_caja;
          });
          sums[index] = Formatter.formatMoney(suma_peso_caja / data.length, 3);
        } else {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = Formatter.formatMoney(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0),
              3
            );
          } else {
            sums[index] = '';
          }
        }
      });

      return sums;
    },

    getTotalAreaFromFarm(farms, farmId) {
      let totalArea = 0;
      const element = Object.values(farms).find((el) => el.id === farmId);
      if (element) {
        totalArea += Number(element.area);
      }

      return totalArea;
    },

    getAreaFromLot(farms, farmId, lotId) {
      let lotArea = 0;
      const element = Object.values(farms).find((el) => el.id === farmId);
      if (element) {
        const lot = Object.values(element.lots).find((l) => l.id === lotId);
        lotArea += Number(lot.area);
      }

      return lotArea;
    },

    /** Elimina un elemento de un array dentro del formulario. */
    removeArrayItem(form, field, index) {
      try {
        if (!Array.isArray(form[field])) {
          console.warn(
            `El campo ${field} no es un array válido en el formulario.`
          );
          return;
        }
        const updatedField = form[field].filter((_, i) => i !== index);
        this.$set(form, field, updatedField);
      } catch (error) {
        console.error(`Error al actualizar ${field}: `, error);
      }
    },
  },

  beforeMount() {
    this.initialModel = { ...this.model };
  },
};

export default mixinMasters;
